import { render, staticRenderFns } from "./PeriodsSidebar.vue?vue&type=template&id=43afc42c&scoped=true&"
import script from "./PeriodsSidebar.vue?vue&type=script&lang=js&"
export * from "./PeriodsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PeriodsSidebar.vue?vue&type=style&index=0&id=43afc42c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43afc42c",
  null
  
)

export default component.exports